(function () {
	'use strict';

	angular.module('mx.shell').controller('mx.shell.PageNotFoundController', function pageNotFoundController() {
		const vm = this;

		vm.attemptUrl = window.location.href;
	});
})();
